module.exports = __webpack_public_path__ + "media/bootstrap-icons/person-circle-b987e009.svg";